import React, { Component } from "react";
import radium from "radium";
import PropTypes from "prop-types";
import Cookies from "js-cookie";
import Container from "backpack-ui/dist/components/container";
import zIndex from "backpack-ui/dist/styles/zIndex";
import ReactCSSTransitionGroup from "react-addons-css-transition-group";

class FeatureDiscover extends Component {

  constructor(props) {
    super(props);

    this.state = {
      visible: false,
    };

    this.handleRemove = this.handleRemove.bind(this);
  }

  componentDidMount() {
    // eslint-disable-next-line react/no-did-mount-set-state
    this.setState({
      visible: !Cookies.get(this.props.featureName),
    });
    if (this.props.removeOnOuterClick) {
      this.setUpEventClickListener();
    }
    if (this.props.removeOnNavigate) {
      this.setUpNavigateListener();
    }
  }

  componentWillUnmount() {
    this.removeListeners();
  }

  setUpEventClickListener() {
    this.clickListener = window.document.body.addEventListener("click", this.handleRemove);
  }

  setUpNavigateListener() {
    window.onbeforeunload = this.handleRemove;
  }

  removeListeners() {
    this.clickListener = null;
  }

  handleRemove() {
    Cookies.set(this.props.featureName, true);
    this.setState({
      visible: false,
    });
  }

  render() {
    return (
      <ReactCSSTransitionGroup
        transitionName="fadeIn"
        transitionAppear
        transitionAppearTimeout={500}
        transitionEnterTimeout={500}
        transitionLeaveTimeout={300}
      >
        {this.state.visible &&
          <Container key={this.props.featureName} style={{ zIndex: zIndex.popup }}>
            {this.props.children}
          </Container>
        }
      </ReactCSSTransitionGroup>
    );
  }
}

FeatureDiscover.propTypes = {
  featureName: PropTypes.string.isRequired,
  children: PropTypes.element.isRequired,
  removeOnOuterClick: PropTypes.bool,
  removeOnNavigate: PropTypes.bool,
};

export default radium(FeatureDiscover);


// WEBPACK FOOTER //
// ./assets/pois/components/featureDiscover/index.jsx